import { isNumber } from 'lodash';
import React from 'react';
import { useQuestPrize } from '../../../../hooks/shared/quests/useQuestPrize';

export default function TaskItemReward({ quest }) {
  const { mainPrize, mainReward } = useQuestPrize(quest);

  return (
    <div className={'task__item-cost'}>
      <img className={'task__item-icon'} src={mainPrize?.image} />

      {isNumber(mainReward) && <div className={'task__item-value'}>{`+${mainReward}`}</div>}
    </div>
  );
}
